export const GET_COLLECTION = '/ranks'